<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import type { InteractiveTitleMultiSelectDefinition } from '../../types';
    import { filter } from 'lodash-es';

    interface Props {
        field: InteractiveTitleMultiSelectDefinition;
    }

    let { field }: Props = $props();

    let options = $derived(field.options);
    let selected = $derived(field.value);

    const dispatch = createEventDispatcher();
    const onChange = (e: { currentTarget: HTMLSelectElement }) => {
        dispatch('change', {
            ...field,
            value: filter(e.currentTarget.options, option => option.selected).map(
                option => option.value,
            ),
        });
    };
</script>

<select value={selected} onchange={onChange} multiple>
    {#each options as { key, label } (key)}
        <option value={key} class:select__active={selected.includes(key)}>{label}</option>
    {/each}
</select>

<style lang="scss" scoped>
</style>
